// src/pages/AuthWarning.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function AuthWarning() {
  return (
    <main
      className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-950
                 flex items-center justify-center px-4 py-12"
      aria-labelledby="auth-warning-title"
    >
      <section
        className="w-full max-w-xl rounded-2xl bg-white/80 dark:bg-slate-900/70 backdrop-blur
                   border border-slate-200/70 dark:border-slate-800 shadow-xl
                   p-6 sm:p-8 text-center animate-in fade-in slide-in-from-bottom-2 duration-300"
        role="alert"
        aria-live="assertive"
      >
        {/* Icone de alerta */}
        <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-amber-100 dark:bg-amber-900/40
                        text-amber-700 dark:text-amber-300 flex items-center justify-center">
          {/* Heroicon: Exclamation Triangle */}
          <svg
            viewBox="0 0 24 24"
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.25 9v3.75m0 3h.008M2.25 12a9.75 9.75 0 1 0 19.5 0 9.75 9.75 0 0 0-19.5 0Z"
            />
          </svg>
        </div>

        {/* Título */}
        <h1
          id="auth-warning-title"
          className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-800 dark:text-slate-100"
        >
          Ação não permitida
        </h1>

        {/* Mensagem */}
        <p className="mt-3 text-slate-600 dark:text-slate-300 leading-relaxed">
          Você não pode proceder com a compra por não estar registrado na plataforma.
          <br className="hidden sm:block" />
          Por favor, faça o login ou cadastre‑se clicando no botão abaixo.
        </p>

        {/* CTA principal */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/login"
            className="inline-flex items-center justify-center w-full sm:w-auto
                       rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white
                       px-5 py-2.5 font-medium shadow-sm transition focus:outline-none
                       focus-visible:ring focus-visible:ring-indigo-400/60"
          >
            Entrar
          </Link>

          <Link
            to="/login"
            className="inline-flex items-center justify-center w-full sm:w-auto
                       rounded-lg bg-white hover:bg-slate-50 text-slate-800
                       dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-100
                       px-5 py-2.5 font-medium border border-slate-200 dark:border-slate-700
                       shadow-sm transition focus:outline-none focus-visible:ring
                       focus-visible:ring-slate-300/60"
          >
            Criar conta
          </Link>
        </div>

        {/* Link de retorno */}
        <div className="mt-5">
          <Link
            to="/"
            className="text-sm font-medium text-slate-600 hover:text-slate-900
                       dark:text-slate-300 dark:hover:text-white underline-offset-4 hover:underline"
          >
            Voltar para a página inicial
          </Link>
        </div>

        {/* Nota de ajuda */}
        <p className="mt-6 text-xs text-slate-500 dark:text-slate-400">
          Precisa de ajuda? <a href="mailto:suporte@seudominio.com" className="underline">Contacte o suporte</a>.
        </p>
      </section>
    </main>
  );
}